import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.local';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {ProfilResponse} from '../../models/profil/Profil';

@Injectable({
  providedIn: 'root'
})
export class ProfilService {
  private currentProfileSubject = new BehaviorSubject<string | null>(null);
  currentProfile$ = this.currentProfileSubject.asObservable();
  private apiUrl = `${environment.apiUrl}/profils`;

  constructor(private http: HttpClient) {
  }

  getProfils(params?: any): Observable<ProfilResponse> {
    return this.http.get<ProfilResponse>(this.apiUrl, {params});
  }

  setCurrentProfile(profile: string) {
    this.currentProfileSubject.next(profile);
  }
}
